<template>
  <div style="padding: 15px 20px">
    <div style="margin-bottom: 10px" class="d-flex">
      <div>
        <a-form-model layout="inline">
          <a-form-model-item label="驱动名称">
            <a-input v-model="queryParams.driverName" />
          </a-form-model-item>
          <a-form-model-item label="协议类型">
            <a-input v-model="queryParams.protocolType" />
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary">查询</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
      <a-space>
        <a-button icon="reload">刷新</a-button>
      </a-space>
    </div>
    <driver-table :driver-page="driverPage" />
  </div>
</template>

<script>
import DriverTable from './components/DriverTable'
export default {
  name: 'index',
  components: { DriverTable },
  data () {
    return {
      queryParams: {
        driverName: '',
        protocolType: ''
      },
      driverPage: {
        records: []
      }
    }
  }
}
</script>

<style scoped>

</style>
